'use es6';

import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getIsReadOnly } from 'FileManagerCore/selectors/Permissions';
import ScopedFeatureTooltip from 'FileManagerCore/components/permissions/ScopedFeatureTooltip';
import { getSelectedFilesAndFolders } from '../../selectors/Selection';
import BulkFileVisibilityPanel from '../modals/BulkFileVisibilityPanel';
import UsageTracker from '../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getI18nKey(suffix) {
  return `FileManagerDashboard.bulkChangeFileVisibility.${suffix}`;
}
class BulkChangeVisibilityButtonAndModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      isChangeVisibilityPanelOpen: false
    };
    this.handleCloseChangeFileVisibilityPanel = () => {
      this.setState({
        isChangeVisibilityPanelOpen: false
      });
    };
    this.openChangeVisibilityPanel = () => {
      this.trackBulkChangeFileVisibilityClicked();
      this.setState({
        isChangeVisibilityPanelOpen: true
      });
    };
  }
  componentDidUpdate(previousProps) {
    if (previousProps.bulkSelection.size !== this.props.bulkSelection.size && this.props.bulkSelection.size === 0) {
      this.setState({
        isChangeVisibilityPanelOpen: false
      });
    }
  }
  trackBulkChangeFileVisibilityClicked() {
    UsageTracker.track('fileManagerFileVisibility', {
      action: 'open visibility panel',
      isBulk: true
    });
  }
  render() {
    const {
      isReadOnly,
      bulkSelection
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ScopedFeatureTooltip, {
        children: /*#__PURE__*/_jsxs(UILink, {
          onClick: this.openChangeVisibilityPanel,
          disabled: isReadOnly,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: "hide"
          }), /*#__PURE__*/_jsx(FormattedMessage, {
            message: getI18nKey('changeVisibility')
          })]
        })
      }), bulkSelection.size > 0 && this.state.isChangeVisibilityPanelOpen && /*#__PURE__*/_jsx(BulkFileVisibilityPanel, {
        onClose: this.handleCloseChangeFileVisibilityPanel
      })]
    });
  }
}
BulkChangeVisibilityButtonAndModal.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  bulkSelection: PropTypes.instanceOf(Immutable.Map).isRequired
};
const mapStateToProps = state => {
  return {
    bulkSelection: getSelectedFilesAndFolders(state),
    isReadOnly: getIsReadOnly(state)
  };
};
export default connect(mapStateToProps)(BulkChangeVisibilityButtonAndModal);